export default __webpack_public_path__ + "static/media/7.2Vid.c5ffd1f7.mp4";